import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { TabContent } from './TabContent';

import type { RenderTab, LinkTabType } from './types';

export const StyledLink = styled(Link)({
  height: '100%',
  boxSizing: 'border-box',
});

export const renderLinkTab: RenderTab = ({
  className,
  label,
  isCurrent,
  onClick,
  tab,
}) => {
  const { to } = tab as LinkTabType;

  return (
    <StyledLink
      className={className}
      onClick={onClick}
      to={to}
    >
      <TabContent
        isCurrent={isCurrent}
        label={label}
        tab={tab}
      />
    </StyledLink>
  );
};
